module.exports = __webpack_public_path__ + "static/img/pcmt_tls.38192f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pcmt_tls.jpg
// module id = mM0Z
// module chunks = 1